// extracted by mini-css-extract-plugin
export default {"searchAddress":"SearchAddress_searchAddress__CADIw"};